var dataLayers = []
import global from 'global'

var tabIdMap = {
  passengers: 'passengerdetails',
  payment: 'paymentdetails',
  'tour-overview': 'touroverview',
}

export const mapBsStageIdToBw = function (dataLayerParameters) {
  var mappedStageId = tabIdMap[dataLayerParameters.stageId]
  if (!mappedStageId) return dataLayerParameters

  dataLayerParameters.stageId = mappedStageId
  return dataLayerParameters
}

var isInitialized = function (dataLayer) {
  return dataLayers.find(el => el === dataLayer)
}

export const push = function (dataLayerParameters) {
  var mappedParameters = mapBsStageIdToBw(dataLayerParameters)

  // GA/GTM properties of window (dataLayer) are injected by GA/GTM after some time - they are not available straight after page load.
  if (!isInitialized(global.dataLayer) && global.dataLayer) {
    dataLayers.push(global.dataLayer) // dataLayer belonging to the brand
  }

  dataLayers.forEach(function (dataLayer) {
    dataLayer.push(mappedParameters)
  })
}

export const reset = function () {
  dataLayers = []
}

export const activateOptimize = function () {
  push({event: 'optimize.activate'})
}
